import { create } from "zustand";
import { isSuppressedUserErrorMessage } from "../Config/api/errorUtils";

const generalStore = (set, get) => ({
    loading: false,
    message: '',
    error: '',
    info: '',
    toastTick: 0,
    heroSearchType: 'cars',
    setHeroSearchType: (value) => {
        set({ heroSearchType: value })
    },
    focusHeroPickupTick: 0,
    requestFocusHeroPickup: () => {
        set((state) => ({
            heroSearchType: 'cars',
            focusHeroPickupTick: state.focusHeroPickupTick + 1,
        }))
    },
    focusHeroDestinationTick: 0,
    requestFocusHeroDestination: () => {
        set((state) => ({
            heroSearchType: 'destinations',
            focusHeroDestinationTick: state.focusHeroDestinationTick + 1,
        }))
    },
    setLoading: (value) => {
        set((state) => ({
            loading: value
        }))
    },
    setMessage: (value) => {
        if (!value) {
            set({ message: '' });
            return;
        }
        set((state) => ({
            message: value,
            toastTick: state.toastTick + 1,
        }))
    },
    setError: (value) => {
        const message = typeof value === 'string' ? value : value?.message || '';
        if (!message) {
            set({ error: '' });
            return;
        }
        if (isSuppressedUserErrorMessage(message) || value?.suppressUserNotification) {
            return;
        }
        set((state) => ({
            error: message,
            toastTick: state.toastTick + 1,
        }))
    },
    setInfo: (value) => {
        if (!value) {
            set({ info: '' });
            return;
        }
        set((state) => ({
            info: value,
            toastTick: state.toastTick + 1,
        }))
    },
})

const useGeneralStore = create(generalStore)
export default useGeneralStore